import React from 'react';
import { Table, Tooltip, Button, Form, Input } from 'antd';
import { DOLARES_AMERICANOS, SOLES } from "../../../../common/types/monedaType";
import { FORMAT_5DECIMALS } from '../../../../common/types/regularExpresionType';
import ConversionModal from "../Conversion/ConversionModal";


export default class ResultList1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            dataItem: {},
        }
    }

    handleOpen = (row) => {
        this.setState({
            visible: true,
            dataItem: row
        })
    }

    render() {
        return (
            <>
                <Table
                    className={'logistica-table-kardex-almacen'}
                    scroll={{ x: true }}
                    size="small"
                    style={{ overflowX: 'auto' }}

                    pagination={false}
                    dataSource={this.props.dataSource}
                    rowKey={record => record.id}
                    columns={[
                        {
                            key: 'options',
                            align: 'center',
                            width: "70px",
                            render: (value, row) => (
                                <div className="custom-options">
                                    <Tooltip placement="top" title={"Editar"}>
                                        <Button
                                            type="primary"
                                            icon="edit"
                                            size={"small"}
                                            onClick={() => this.handleOpen(row)}

                                        />
                                    </Tooltip>
                                </div>
                            )
                        },
                        {
                            title: 'Nombre',
                            dataIndex: 'nombreProducto',
                            key: 'nombreProducto'
                        },
                        {
                            title: 'Unidad Medida',
                            dataIndex: 'nombreUnidadMedida',
                            key: 'nombreUnidadMedida'
                        },
                        {
                            title: 'Precio Promedio Soles',
                            dataIndex: 'precioPromedioSolesStr',
                            key: 'precioPromedioSolesStr',
                            align: 'right',
                            className: 'column-promedio',
                        },
                        {
                            title: 'Costo Promedio Soles',
                            dataIndex: 'valorPromedioSolesStr',
                            key: 'valorPromedioSolesStr',
                            className: 'column-promedio',
                            align: 'right'
                        },
                        {
                            title: 'Precio Promedio Dólares',
                            dataIndex: 'precioPromedioDolaresStr',
                            key: 'precioPromedioDolaresStr',
                            className: 'column-promedio',
                            align: 'right'
                        },

                        {
                            title: 'Costo Promedio Dólares',
                            dataIndex: 'valorPromedioDolaresStr',
                            key: 'valorPromedioDolaresStr',
                            className: 'column-promedio',
                            align: 'right'
                        },

                        {
                            title: 'Valor Unitario Soles',
                            dataIndex: 'valorUnitarioSoles',
                            key: 'valorUnitarioSoles',
                            align: 'right',
                            className: this.props.onGetFieldValue('idMoneda') === SOLES ? '' : 'column-total',
                            render: (value, row,) => {
                                return (<span>{value.toFixed(5)}</span>);
                            }
                        },
                        {
                            title: 'Precio Unitario Soles',
                            dataIndex: 'precioUnitarioSoles',
                            key: 'precioUnitarioSoles',
                            align: 'right',
                            className: this.props.onGetFieldValue('idMoneda') === SOLES ? '' : 'column-total',
                            render: (value, row) => {
                                return (<span>{value.toFixed(5)}</span>);
                            }
                        },
                        {
                            title: 'Valor Unitario Dólares',
                            dataIndex: 'valorUnitarioDolares',
                            key: 'valorUnitarioDolares',
                            align: 'right',
                            className: this.props.onGetFieldValue('idMoneda') === DOLARES_AMERICANOS ? '' : 'column-total',
                            render: (value, row) => {
                                return (<span>{value.toFixed(5)}</span>);
                            }
                        },
                        {
                            title: 'Precio Unitario Dólares',
                            dataIndex: 'precioUnitarioDolares',
                            key: 'precioUnitarioDolares',
                            align: 'right',
                            className: this.props.onGetFieldValue('idMoneda') === DOLARES_AMERICANOS ? '' : 'column-total',
                            render: (value, row) => {
                                return (<span>{value.toFixed(5)}</span>);
                            }
                        }
                    ]}
                />
                <ConversionModal
                    visible={this.state.visible}
                    moneda={this.props.onGetFieldValue('idMoneda')}
                    formValues={this.state.dataItem}
                    onClose={() => this.setState({ visible: false })}
                    precioUnitarioIncluyeIGV={this.props.precioUnitarioIncluyeIGV}
                    onSaveExpand={this.props.onSaveExpand}
                />
            </>
        );
    }
}